// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"b63e7df7","604":"faaa6a12"}[chunkId] + ".chunk.css";
};